"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CategoryHero() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const [time, setTime] = useState("");
  const [mode, setMode] = useState("OPERACIÓN DÍA");
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      setTime(`${hours}:${minutes}`);
    };
    updateTime();
    const interval = setInterval(updateTime, 60000);
    const modeInterval = setInterval(() => {
      setMode(prev => prev === "OPERACIÓN DÍA" ? "TURNO NOCTURNO" : "OPERACIÓN DÍA");
    }, 12000);
    return () => {
      clearInterval(interval);
      clearInterval(modeInterval);
    };
  }, []);
  return <section data-section-id="5218" id="category-hero" className="bg-background text-foreground relative h-screen min-h-[700px] w-full overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_acero_industrial_facility.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_acero_industrial_facility.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_acero_industrial_facility.png-wvc-sizes" alt="Instalaciones industriales de Kalisch Acero con estructuras metálicas de alta precisión" loading="eager" decoding="async" className="h-full w-full object-cover scale-105 animate-[slow-zoom_20s_ease-in-out_infinite_alternate]" />
        {}
        <div className="absolute inset-0 bg-background/40" />
        {}
        <div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse at center, transparent 30%, hsla(125, 55%, 10%, 0.5) 100%)"
      }} />
        {}
        <div className="absolute inset-0 opacity-20" style={{
        background: "radial-gradient(circle at center, hsla(19, 89%, 54%, 0.2) 0%, transparent 60%)"
      }} />
      </div>

      {}
      <div className="absolute top-6 left-6 md:top-10 md:left-10 z-20">
        <div className="flex items-center gap-2 font-mono text-[10px] md:text-xs tracking-[0.3em] text-primary uppercase">
          <span className="inline-block w-1.5 h-1.5 rounded-lg bg-accent animate-pulse" />
          <span>{mode}</span>
        </div>
      </div>

      {}
      <div className="absolute top-6 right-6 md:top-10 md:right-10 z-20">
        <span className="font-default text-base md:text-lg tracking-[0.25em] text-primary font-bold">
          KALISCH
        </span>
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col justify-end pb-20 md:pb-28 px-6 md:px-16 lg:px-24">
        <div className="max-w-4xl">
          {}
          <div ref={eyebrowRef} className={`mb-8 md:mb-10 transition-all duration-1000 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <span className="font-mono text-[10px] md:text-xs tracking-[0.4em] text-primary uppercase font-semibold">
              Líderes en Acero &nbsp;/&nbsp; México
            </span>
          </div>

          {}
          <h1 ref={headlineRef} className={`font-default font-bold text-foreground leading-[0.95] tracking-tight transition-all duration-1000 delay-100 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <span className="block text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[7.5rem]">
              Forjando el
            </span>
            <span className="block text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[7.5rem]">
              Futuro
            </span>
            <span className="block font-bold text-secondary text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[6rem] mt-1">
              Acero de Calidad.
            </span>
          </h1>

          {}
          <p ref={bodyRef} className={`mt-8 md:mt-10 max-w-[480px] text-foreground/80 text-base md:text-lg leading-relaxed font-default transition-all duration-1000 delay-200 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Soluciones integrales en acero para la construcción e industria. Desde perfiles estructurales hasta trefilados, impulsamos el desarrollo de México con infraestructura sólida y sostenible.
          </p>

          {}
          <div ref={ctaRef} className={`mt-10 md:mt-12 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8 transition-all duration-1000 delay-300 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary-600 px-8 py-6 h-auto text-sm tracking-[0.2em] uppercase rounded-md font-semibold shadow-md">
              <Link to="/CatalogPage">Ver Catálogo</Link>
            </Button>

            <Link to="/ProductsPage" className="group inline-flex items-center gap-3 text-foreground hover:text-primary transition-colors text-sm tracking-[0.2em] uppercase font-semibold">
              <span>Nuestros Productos</span>
              <ArrowRight className="size-4 transition-transform duration-500 ease-out group-hover:translate-x-2" />
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 right-6 md:bottom-12 md:right-16 z-20 hidden sm:flex flex-col items-end gap-3">
        <div className="flex flex-col items-end gap-1">
          <span className="font-mono text-[10px] tracking-[0.3em] text-muted-foreground uppercase">
            Hora Local
          </span>
          <span className="font-mono text-sm tracking-[0.2em] text-foreground font-medium">
            {time}
          </span>
        </div>
        <div className="flex flex-col items-end gap-1">
          <span className="font-mono text-[10px] tracking-[0.3em] text-muted-foreground uppercase">
            Producción
          </span>
          <span className="font-mono text-sm tracking-[0.2em] text-foreground font-medium">
            100% ACTIVA
          </span>
        </div>
      </div>

      {}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-3">
        <span className="font-mono text-[9px] tracking-[0.4em] text-muted-foreground uppercase hidden md:block">
          Explorar
        </span>
        <div className="relative h-[60px] w-px bg-primary/30 overflow-hidden">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1 h-1 rounded-lg bg-accent animate-[scroll-dot_2.4s_ease-in-out_infinite]" />
        </div>
      </div>

      <style>{`
        @keyframes slow-zoom {
          0% { transform: scale(1.02); }
          100% { transform: scale(1.08); }
        }
        @keyframes scroll-dot {
          0% { transform: translate(-50%, 0); opacity: 0; }
          20% { opacity: 1; }
          80% { opacity: 1; }
          100% { transform: translate(-50%, 56px); opacity: 0; }
        }
      `}</style>
    </section>;
}